import { OosConfirmationContent } from "../components/OosConfirmationContent";
import { useEffect } from "react";
import { useAppDispatch } from "../store/hooks";
import { reset } from "../store";
import { ViewMode } from "@/types";

export const OosConfirmation = ({ mode }: { mode?: ViewMode }) => {
  const dispatch = useAppDispatch();

  // Reset Redux state when component unmounts
  useEffect(() => {
    return () => {
      dispatch(reset());
    };
  }, [dispatch]);

  return <OosConfirmationContent mode={mode} />;
};
